

















































import { MobileSubscriptionDTO } from '@accounting/interfaces/fallback-mobile-app-payment';

import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-payment-result-subscription-card',
  components: {},
})
export default class PaymentResultBookingCard extends Vue {
  @Prop({ type: Object }) readonly subscription: MobileSubscriptionDTO;
  get hasSlots(): boolean {
    return !!this.subscription.slots?.length;
  }

  get validSlots(): string {
    return this.subscription.slots?.join(' + ') || '';
  }

  get disciplines(): string {
    return this.subscription.disciplines?.join(' + ') || '';
  }

  get typeTranslation(): string {
    const subscriptionType = this.subscription.type;
    switch (subscriptionType) {
      case 'membership':
        return this.$t('global.subscription_category.membership') as string;
      case 'subscription':
        return this.$t('global.subscription_category.subscription') as string;
      case 'time_based':
        return this.$t('global.subscription_category.time_based_subscription') as string;
      default:
        return '';
    }
  }
}
